import { useSelector } from 'react-redux'

import { selectCustomerNotificationsSettings } from '@/features/domain/territory'
import { NotificationFormValues } from '@/notificationForms'

export type NotCompletedNotificationValues = ReturnType<typeof useNotCompletedNotificationValues>

/**
 * That hook grabs notCompletedNotification values from the domain and returns them
 */
export function useNotCompletedNotificationValues(): NotificationFormValues {
  const notificationSettings = useSelector(selectCustomerNotificationsSettings)

  return {
    ...notificationSettings['notCompletedSettings'],
    windowOfCommitmentToleranceMins: '30',
    notificationCutoffMins: 0,
    proximityThresholdMins: '10',
    toleranceMins: 'No',
    windowOfCommitmentSnapToMins: 0,
    alwaysNotifyAfterCutoff: false,
  }
}
